import React from "react";
import type { ScrollerProps } from "react-virtuoso";

export function CalendarScroller({ ref, style, children, ...props }: ScrollerProps) {
	return (
		<React.Fragment>
			<div
				className="w-full h-full overflow-x-auto relative"
				style={{
					position: "relative",
					...style,
				}}
				ref={ref}
				{...props}
			>
				{children}
			</div>
		</React.Fragment>
	);
}
